import React from "react";
import { getShopBusinessLinks } from "./shopDisplayHelpers";

export function BusinessLinkIcon({ type }) {
  if (type === "map") {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z" />
        <circle cx="12" cy="10" r="2.5" />
      </svg>
    );
  }
  if (type === "website") {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9S14.5 18.5 12 21M12 3C9.5 5.5 8.5 8.5 8.5 12S9.5 18.5 12 21" />
      </svg>
    );
  }
  if (type === "facebook") {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="currentColor">
        <path d="M13.5 21v-8h2.7l.4-3h-3.1V8.1c0-.9.2-1.6 1.6-1.6h1.7V3.8c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3V10H8v3h2.1v8h3.4z" />
      </svg>
    );
  }
  if (type === "google") {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="currentColor">
        <path d="M12.24 10.4v3.32h4.6c-.2 1.18-1.4 3.46-4.6 3.46-2.77 0-5.03-2.29-5.03-5.11s2.26-5.11 5.03-5.11c1.58 0 2.63.67 3.24 1.25l2.2-2.12C16.9 4.76 14.77 3.8 12.24 3.8 7.9 3.8 4.4 7.3 4.4 11.64s3.5 7.84 7.84 7.84c4.53 0 7.53-3.18 7.53-7.66 0-.51-.06-.9-.13-1.29l-7.4-.03z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="currentColor">
      <path d="M21.6 7.2a3.1 3.1 0 0 0-2.2-2.2C17.5 4.5 12 4.5 12 4.5s-5.5 0-7.4.5a3.1 3.1 0 0 0-2.2 2.2C2 9.1 2 12 2 12s0 2.9.4 4.8a3.1 3.1 0 0 0 2.2 2.2c1.9.5 7.4.5 7.4.5s5.5 0 7.4-.5a3.1 3.1 0 0 0 2.2-2.2c.4-1.9.4-4.8.4-4.8s0-2.9-.4-4.8ZM10.2 15.3V8.7L15.8 12l-5.6 3.3Z" />
    </svg>
  );
}

export default function ShopBusinessLinks({ shop, mapsUrl = "", className = "mt-2" }) {
  const links = getShopBusinessLinks(shop, mapsUrl);
  if (links.length === 0) return null;
  return (
    <div className={`flex items-center gap-2 text-gray-700 dark:text-gray-200 ${className}`}>
      {links.map((link) => (
        <a
          key={link.key}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-full border p-1.5 hover:bg-gray-50 dark:hover:bg-gray-700"
          title={link.title}
          aria-label={link.label}
        >
          <BusinessLinkIcon type={link.type} />
        </a>
      ))}
    </div>
  );
}
